import { TooltipNew } from 'ui';
import { AIIcon } from 'ui/icons';

interface CreatedByAiLabelProps {
  createdWithAi?: boolean;
  aiStatus?: string | null;
}

export const CreatedByAiLabel = ({ createdWithAi, aiStatus }: CreatedByAiLabelProps) => {
  const isCorrection = aiStatus === 'correction';
  const isAiCreated = aiStatus === 'ai' || createdWithAi;

  return (
    <>
      {(isAiCreated || isCorrection) && (
        <TooltipNew
          text={
            isCorrection
              ? 'Created automatically by AI to reconcile portfolio balances.'
              : 'Created by AI'
          }
        >
          <div className="flex items-center font-medium text-purple-500 text-[12px]">
            <img alt="logo" src={AIIcon} className="h-[20px] w-[20px] mr-[2px]" />
            <span>{isCorrection ? 'AI Correction' : 'AI'}</span>
          </div>
        </TooltipNew>
      )}
    </>
  );
};
